import BaseRepository from './BaseRepository';

class ExclusionListRepository extends BaseRepository {
  public getExclusionLists(): Promise<any[]> {
    return this.httpClient
      .get(`/v2/users/round_report_exclusion_lists`)
      .then(res => res.data.data.organizations)
      .catch(_ => null);
  }

  public toggleExclusionList(organizationId: string): Promise<any[]> {
    return this.httpClient
      .post(`/v2/users/round_report_exclusion_lists`, { organization_id: organizationId })
      .then(res => res.data.data.organizations)
      .catch(_ => null);
  }
}

export default ExclusionListRepository;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/repository/ExclusionListRepository.ts